import { Button, List, ListItem, ListItemText, Paper, Stack, Typography } from '@mui/material';
import { Link } from 'react-router';

import { activeOrgName, displayName, useMe } from '../lib/me';

/** The welcome page of a portal whose features are still to come. */
export function AreaHome({ title, features }: { title: string; features: string[] }) {
  const { data: me } = useMe();
  if (!me) return null;
  return (
    <Stack spacing={3} sx={{ maxWidth: 640 }}>
      <div>
        <Typography variant="h4">Welcome, {displayName(me)}</Typography>
        <Typography color="text.secondary">
          {title} · {activeOrgName(me)}
        </Typography>
      </div>
      <Paper variant="outlined" sx={{ p: 3 }}>
        <Typography variant="h6">Coming Soon</Typography>
        <List dense>
          {features.map((feature) => (
            <ListItem key={feature} disableGutters>
              <ListItemText primary={feature} />
            </ListItem>
          ))}
        </List>
      </Paper>
      <Paper variant="outlined" sx={{ p: 3 }}>
        <Typography variant="h6">Keep Your Details Current</Typography>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          Your phone number and email are how {activeOrgName(me)} reaches you.
        </Typography>
        <Button variant="outlined" component={Link} to="/account">
          Go to my profile
        </Button>
      </Paper>
    </Stack>
  );
}
